import { render, staticRenderFns } from "./VideoCardVertical.vue?vue&type=template&id=52db3844&scoped=true&"
import script from "./VideoCardVertical.vue?vue&type=script&lang=js&"
export * from "./VideoCardVertical.vue?vue&type=script&lang=js&"
import style0 from "./VideoCardVertical.vue?vue&type=style&index=0&id=52db3844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52db3844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VList,VListItem,VListItemAction,VListItemContent,VListItemSubtitle,VRow})
